<template>
  <div id="app">
    <Top />
  </div>
</template>

<script>
import Top from './components/Top.vue';

export default {
  name: 'App',
  components: {
    Top,
  },
};
</script>

<style lang="scss">
html,
body {
  height: 100%;
}

body {
  image-rendering: crisp-edges;
  background-color: #009900;
  margin: 0;
  height: 10000px;
}
</style>
